import { TFunction } from 'i18next'

import { IRange } from 'widgets/tour/date-range-picker'

import { getFlexibleDateRange } from 'entities/tour/libs/getFlexibleDateRange.ts'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { dateFormat } from 'shared/lib/dateFormat.ts'

interface getNightTextProps {
  t: TFunction
  nights?: number
  isFlexibleNights?: boolean
}

export const getNightsText = ({
  t,
  nights,
  isFlexibleNights,
}: getNightTextProps) => {
  const value = nights || 0

  if (isFlexibleNights) {
    return t('tours_block.dynamic_nights', { nights: value })
  }

  return t('tours_block.nights_short', { night: value })
}

export const getButtonText = (
  selectedDates: IRange | null,
  isFlexibleDeparture?: boolean,
) => {
  if (!isFlexibleDeparture || !selectedDates?.startDate) {
    return dateFormat(
      selectedDates?.startDate || '',
      DATE_FORMAT_LIST.DATE_MONTH,
    )
  }

  const { startRange, endRange } = getFlexibleDateRange(selectedDates.startDate)
  return `${dateFormat(startRange, DATE_FORMAT_LIST.DAY)}-${dateFormat(endRange, DATE_FORMAT_LIST.DATE_MONTH)}`
}
